import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Envasado/eliminarDosisSeleccion`, method: 'POST', body: {list}, token: token})
}